import { render, staticRenderFns } from "./VerificarSenhas.vue?vue&type=template&id=44af4a57"
import script from "./VerificarSenhas.vue?vue&type=script&lang=js"
export * from "./VerificarSenhas.vue?vue&type=script&lang=js"
import style0 from "./VerificarSenhas.vue?vue&type=style&index=0&id=44af4a57&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports